export default __webpack_public_path__ + "static/hero-6-69d983e4308a488f9ec0106fb9c73d4d.webp";